import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class EnvironmentService {

  private activeEnvironment;

  constructor() {
    const apiSettings = JSON.parse(localStorage.getItem('api-settings'));
    this.activeEnvironment = environment;
    if (environment.changeApi && apiSettings) {
      if (apiSettings.usedApi === 'live') {
        this.activeEnvironment.imageAssetPath = environment.live.imageAssetPath;
        this.activeEnvironment.videoAssetPath = environment.live.videoAssetPath;
        this.activeEnvironment.audioAssetPath = environment.live.audioAssetPath;
        this.activeEnvironment.fileAssetPath = environment.live.fileAssetPath;
        this.activeEnvironment.mediaAssetPath = environment.live.mediaAssetPath;
        this.activeEnvironment.apiBaseURL = environment.live.apiBaseURL;
      }
      if (apiSettings.usedApi === 'staging') {
        this.activeEnvironment.imageAssetPath = environment.staging.imageAssetPath;
        this.activeEnvironment.videoAssetPath = environment.staging.videoAssetPath;
        this.activeEnvironment.audioAssetPath = environment.staging.audioAssetPath;
        this.activeEnvironment.fileAssetPath = environment.staging.fileAssetPath;
        this.activeEnvironment.mediaAssetPath = environment.staging.mediaAssetPath;
        this.activeEnvironment.apiBaseURL = environment.staging.apiBaseURL;
      }
    }
  }

  public getImageAssetPath(): string {
    return this.activeEnvironment.imageAssetPath;
  }

  public getVideoAssetPath(): string {
    return this.activeEnvironment.videoAssetPath;
  }

  public getAudioAssetPath(): string {
    return this.activeEnvironment.audioAssetPath;
  }

  public getFileAssetPath(): string {
    return this.activeEnvironment.fileAssetPath;
  }

  public getMediaAssetPath(): string {
    return this.activeEnvironment.mediaAssetPath;
  }

  public getLogFileRequestUrl(): string {
    return this.activeEnvironment.logFileRequestUrl;
  }

  public getPipeBackendUrl(): string {
    return this.activeEnvironment.pipeUrl;
  }
}
